import { FootballStatKey, CalculatedFootballStatKey } from '@pff-consumer/schema'
import { FOOTBALL_STAT_DISPLAY_TEXTS } from './football-stat-constants'

export const getFootballStatName = (
  key: FootballStatKey | CalculatedFootballStatKey,
  nameLength: 'short' | 'medium' | 'long'
): string => {
  return FOOTBALL_STAT_DISPLAY_TEXTS[key]?.[nameLength] || ''
}
